import AbstractOverlay from './AbstractOverlay';


const config = {
    symbolSize: 70,
    color: "#F62157", //标志颜色
    symbol: 'pin',
    label: true,
    animation:true,
    labelFormatter: function (params) {
        return params.value[2] + "%";
    },
    labelSize: 9,
    labelColor: "#fff",
    labelPosition: 'inside',
    tooltip: {
        show: true,
        formatter: function (params) {
            return params.name + ":" + params.value[2] + "%";
        }
    },
    splitList: [],
    zlevel: 1,
};

export default class ScatterPinOverlay extends AbstractOverlay {
    constructor(opts) {
        super(config, opts);
    }

    /**
     * 转换echarts结构
     */
    toString() {
        // debugger
        return this.data.map((element) => {
            let {
                symbolSize,
                color,
                label,
                symbol,
                labelColor,
                labelSize,
                labelPosition,
                tooltip,
                zlevel
            } = this._getSplitListStyle(element);
            return {
                name: element.name,
                type: 'scatter',
                animation: this.animation,
                coordinateSystem: 'bmap',
                symbol: symbol,
                symbolSize: symbolSize,
                itemStyle: {
                    normal: {
                        color: color, //标志颜色
                    }
                },
                label: {
                    normal: {
                        formatter: function (params) {
                            return params.value[2] + "%";
                        },
                        show: label,
                        textStyle: {
                            color: labelColor || color,
                            fontSize: labelSize,
                        },
                        position: labelPosition,
                    }
                },

                tooltip: tooltip,
                data: [this._geoPointToEchart(element)],
                zlevel
            };
        });
    }
}